import { Box, Card, Grid, IconButton, Typography } from "@mui/material";
import React from "react";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import NewFeatureComingSoon from "../messages/NewFeatureComming";

const Notifications = () => {
  return (
    <Card sx={{ boxShadow: 1, height: 400, borderRadius: 4 }}>
      {/* <Box sx={{}}>
        <Grid container>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            sx={{
              display: "flex",
              alignItems: "center",
              position: "sticky",
              top: 0,
              borderBottom: 1,
            }}>
            <IconButton>
              <NotificationsActiveOutlinedIcon />
            </IconButton>
            <Typography variant="h6">Notifications</Typography>
            <hr />
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            sx={{ overflow: "auto", height: 350 }}>
            <StripedTable />
          </Grid>
        </Grid>
      </Box> */}
      <NewFeatureComingSoon />
    </Card>
  );
};

export default Notifications;
